import React from "react";
import ButtonBorder from "./components/Button/ButtonBorder";
import Icon from "./components/Icon/Icon";
import BtnGroup from "./components/BtnGroup/BtnGroup";

import coinIcon from "icons/coin.svg";
import chatIcon from "icons/chat.svg";
import refIcon from "icons/ref.svg";
import personIcon from "icons/person.svg";
import ButtonIcon from "./components/Button/ButtonIcon";


class UIKit extends React.Component {
  render() {
    return (
      <div>
        <p>Кнопка</p>
        <ButtonBorder onClick={ () => alert("clicked") }>Отправить</ButtonBorder>

        <p>Иконка</p>
        <Icon glyph={ coinIcon }/>

        <p>Кнопка с иконкой</p>
        <ButtonIcon glyph={ chatIcon }>Чат</ButtonIcon>

        <p>Группа кнопок</p>
        <BtnGroup>
          <ButtonIcon glyph={ chatIcon } className="active">Чат</ButtonIcon>
          <ButtonIcon glyph={ refIcon }>Рефералы</ButtonIcon>
          <ButtonIcon glyph={ personIcon }>Кабинет</ButtonIcon>
        </BtnGroup>
      </div>
    );
  }
}

export default UIKit;


// WEBPACK FOOTER //
// ./app/UIKit.jsx